module.exports = __webpack_public_path__ + "static/img/aliados_estudiantes.dd1fc91.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/alliance/aliados_estudiantes.png
// module id = MtWU
// module chunks = 47